import { put } from 'redux-saga/effects';
import { navigate } from '../../../processes/navigation';
import { WORKSPACE_ROUTE } from '../../history';

export function* linkedinAuthWorker() {
  yield put(navigate({ to: WORKSPACE_ROUTE }));
}
